import { typedQueryClient, useTypedMutation } from "hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeleteSnoozePayload } from "components";

export const useDeleteNotSnoozedSnoozeMutation = () =>
  useTypedMutation<DeleteSnoozePayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/snoozes/delete", payload);
    },
    onSuccess: ({ intervention_id, question_result_id }) => {
      const notSnoozedLeads = typedQueryClient.getQueryData(LeadsQueryKeys.listNotSnoozed);
      if (!notSnoozedLeads?.items?.length) return;

      const snoozeIdx = notSnoozedLeads.items.findIndex(i => (intervention_id ? i.intervention_id === intervention_id : i.question_result_id === question_result_id));
      if (snoozeIdx === -1) return;

      typedQueryClient.setQueryData(LeadsQueryKeys.listNotSnoozed, {
        ...notSnoozedLeads,
        items: notSnoozedLeads.items.toSpliced(snoozeIdx, 1),
        nb_items: notSnoozedLeads.nb_items - 1
      });
    }
  });
